const TRACK_VAR = 'common/omniture/TRACK_VAR';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case TRACK_VAR:
      return {
        ...state,
        [action.key]: action.value
      };
    default:
      return state;
  }
}

export function trackVar(key, value) {
  return {
    type: TRACK_VAR,
    key,
    value
  };
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/omniture.js